// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Remove focus highlight border from all input elements */
input:focus,
textarea:focus,
select:focus,
button:focus,
[contenteditable]:focus,
.input:focus,
.textArea:focus,
.primaryTextarea:focus,
.secondaryTextarea:focus,
.card:focus,
.searchResultButton:focus,
.subsectionLabel:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #3a3a3a !important;
}

/* Custom styling for form validation messages */
:root {
  --primary-color: #6366F1;
  --primary-light: rgba(99, 102, 241, 0.2);
  --text-color: #e0e0ff;
  --dark-bg: #1A1A1E;
}

/* Custom validation popup styling */
input:invalid,
textarea:invalid {
  box-shadow: none;
}

/* Style the validation popup */
input:focus:invalid,
textarea:focus:invalid {
  border-color: rgba(99, 102, 241, 0.5) !important;
}

/* Custom validation message styling using ::before for the popup triangle/arrow */
input:invalid:required:not(:placeholder-shown)::before,
textarea:invalid:required:not(:placeholder-shown)::before {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 10px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid var(--dark-bg);
  z-index: 1001;
}

/* The actual validation message popup */
input::-webkit-validation-bubble,
textarea::-webkit-validation-bubble {
  background: var(--dark-bg) !important;
  color: var(--text-color) !important;
  border: 1px solid rgba(99, 102, 241, 0.3) !important;
  border-radius: 10px !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  backdrop-filter: blur(5px) !important;
  animation: fadeIn 0.2s ease-out !important;
}

/* For Firefox and other browsers */
input:-moz-ui-invalid,
textarea:-moz-ui-invalid {
  box-shadow: none;
  border-color: rgba(99, 102, 241, 0.5) !important;
}

/* Disable native validation popup styles */
::-webkit-validation-bubble-message {
  display: none;
}

/* Alternative approach using CSS custom properties */
@supports (--custom: property) {
  form {
    --error-color: rgba(99, 102, 241, 0.8);
  }
}

/* Animation for the validation popup */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,0DAA0D;AAC1D;;;;;;;;;;;;EAYE,wBAAwB;EACxB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;EACE,wBAAwB;EACxB,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;;EAEE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;;EAEE,gDAAgD;AAClD;;AAEA,kFAAkF;AAClF;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,uCAAuC;EACvC,aAAa;AACf;;AAEA,wCAAwC;AACxC;;EAEE,qCAAqC;EACrC,mCAAmC;EACnC,oDAAoD;EACpD,8BAA8B;EAC9B,qDAAqD;EACrD,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;;EAEE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA,2CAA2C;AAC3C;EACE,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Remove focus highlight border from all input elements */\ninput:focus,\ntextarea:focus,\nselect:focus,\nbutton:focus,\n[contenteditable]:focus,\n.input:focus,\n.textArea:focus,\n.primaryTextarea:focus,\n.secondaryTextarea:focus,\n.card:focus,\n.searchResultButton:focus,\n.subsectionLabel:focus {\n  outline: none !important;\n  box-shadow: none !important;\n  border-color: #3a3a3a !important;\n}\n\n/* Custom styling for form validation messages */\n:root {\n  --primary-color: #6366F1;\n  --primary-light: rgba(99, 102, 241, 0.2);\n  --text-color: #e0e0ff;\n  --dark-bg: #1A1A1E;\n}\n\n/* Custom validation popup styling */\ninput:invalid,\ntextarea:invalid {\n  box-shadow: none;\n}\n\n/* Style the validation popup */\ninput:focus:invalid,\ntextarea:focus:invalid {\n  border-color: rgba(99, 102, 241, 0.5) !important;\n}\n\n/* Custom validation message styling using ::before for the popup triangle/arrow */\ninput:invalid:required:not(:placeholder-shown)::before,\ntextarea:invalid:required:not(:placeholder-shown)::before {\n  content: \"\";\n  position: absolute;\n  bottom: -8px;\n  left: 10px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid var(--dark-bg);\n  z-index: 1001;\n}\n\n/* The actual validation message popup */\ninput::-webkit-validation-bubble,\ntextarea::-webkit-validation-bubble {\n  background: var(--dark-bg) !important;\n  color: var(--text-color) !important;\n  border: 1px solid rgba(99, 102, 241, 0.3) !important;\n  border-radius: 10px !important;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;\n  padding: 12px 16px !important;\n  font-size: 14px !important;\n  backdrop-filter: blur(5px) !important;\n  animation: fadeIn 0.2s ease-out !important;\n}\n\n/* For Firefox and other browsers */\ninput:-moz-ui-invalid,\ntextarea:-moz-ui-invalid {\n  box-shadow: none;\n  border-color: rgba(99, 102, 241, 0.5) !important;\n}\n\n/* Disable native validation popup styles */\n::-webkit-validation-bubble-message {\n  display: none;\n}\n\n/* Alternative approach using CSS custom properties */\n@supports (--custom: property) {\n  form {\n    --error-color: rgba(99, 102, 241, 0.8);\n  }\n}\n\n/* Animation for the validation popup */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
